import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { RollStatusObserver } from '@/features/roll/components/roll-status-observer'
import { useNotificationQueueProcessor } from '@/features/notifications/hooks/use-notification-queue-processor'
import { Header } from './header'
import { Navbar } from './navbar'

export function AppLayout() {
  const { user } = useAuth()

  console.log('🏗️ [AppLayout] Renderizando, user:', user?.id)

  // Processar fila de notificações em tempo real
  useNotificationQueueProcessor()

  if (!user) {
    console.log('🚫 [AppLayout] Sem usuário, redirecionando para login')
    return <Navigate to="/login" replace />
  }

  console.log('✅ [AppLayout] Usuário autenticado, renderizando layout')

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <RollStatusObserver />
      <Header />

      {/* Main Content */}
      <main className="mx-auto mt-16 w-full max-w-screen-xl flex-1 px-4 py-8 pb-24">
        <Outlet />
      </main>

      <Navbar />
    </div>
  )
}


// COMMENT ALEATORIO PARA FORÇAR UPDATE DO GIT